import { useMemo, type ReactNode } from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "@mui/material/styles";
import { createBrkTheme } from "@/theme/theme";

// Emotion's styles are PREPENDED to <head> so Tailwind's utilities still win a
// specificity tie while pages mix the two. There is no CssBaseline: Tailwind's
// preflight is the baseline, as it already is for every existing page.
const cache = createCache({ key: "brk", prepend: true });

export function BrkThemeProvider({ children }: { children: ReactNode }) {
  const theme = useMemo(() => createBrkTheme(), []);
  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
}
